/* eslint no-restricted-syntax:0 */
import { webviewInfo, util } from '@ali/amap-lib';

const host = window.location.hostname;
const isPublic = webviewInfo.isPublic();
const legacyPreHost = 'h5-cms-test.oss-cn-hangzhou-zmf.aliyuncs.com';
const preHosts = ['pre-cache.amap.com'];
const isPreEnv = preHosts.includes(host)
  || (util.getUrlParam('pre') && host === legacyPreHost); // 是否预发环境
console.log(`%cLINKURL 是否强制使用预发环境-->>${isPreEnv}`, 'color: orange');

const LINKURL = {}; // output
const linkURL = {
  // 注意此处https
  index: {
    test: 'https://testing.amap.com/activity/2019PushTemplate/index.html',
    pre: 'https://pre-cache.amap.com/activity/2019PushTemplate/index.html',
    public: 'https://static6.autonavi.com/activity/2019PushTemplate/index.html'
  },
  // 注意此处http
  callNative: {
    test: 'http://testing.amap.com/activity/2019XXX/callNative.html',
    public: 'http://gaode.amap.com/2019XXX/callNative.html'
  },
  // 我的奖品,AmapApp.util.goAward()
  awardlist: {
    test: '//group.testing.amap.com/public/activity/common/page/awardlist.html',
    public: '//cache.amap.com/activity/common/page/awardlist.html'
  },

  /*  其他接口 */
  // actid 与identify 请求发券和领券的固定参数
  actid: {
    test: '6cb49bf3',
    public: 'caad7125'
  },
  identify: {
    test: 'push_draw_coupon',
    public: 'push_draw_coupon'
  },
};

Object.keys(linkURL).forEach((pageName) => {
  if (isPreEnv) {
    LINKURL[pageName] = linkURL[pageName].pre;
  } else if (isPublic) {
    LINKURL[pageName] = linkURL[pageName].public;
  } else {
    LINKURL[pageName] = linkURL[pageName].test;
  }
});
export default LINKURL;
